import React from 'react';
import PropTypes from 'prop-types';
import superagent from 'superagent';
import InterestingDistricts from './Components/InterestingDistricts';
import { Wrapper, Left, Middle, Right } from './Symbols/WidgetLayout';
import WidgetList from './Components/WidgetList';
import Summary from './Components/WidgetSummary/WidgetSummaryWithLogo';
import { sortBy } from './Utils/Sorters';

const emptyMeta = {
	turnout: 0
};

export default class App extends React.PureComponent {
	state = {
		meta: emptyMeta,
		leaders: {},
		districts: [],
		parties: []
	}
	componentDidMount() {
		superagent
			.get(`${this.props.rootUrl}senate/${this.props.year}/vysledky_souhrn.json`)
			.then((data) => {
				this.setState({
					meta: data.body.meta[1] || emptyMeta,
					leaders: data.body.leaders[1] || {},
					districts: (this.props.interestingDistricts || this.props.districts.slice(0, 3)).map(district => {
						const finalists = data.body.finalists.filter((item) => item.area.id === district).sort(sortBy(1, 'votes'));
						return {
							...(data.body.leaders[0][district] || {}).area,
							names: finalists.map(candidate => candidate.lastName)
						};
					}).filter(Boolean),
					parties: Object.values(Object.values(data.body.leaders[1]).reduce((parties, leader) => {
						if (!parties[leader.party.id]) {
							parties[leader.party.id] = {
								...leader.party,
								count: 0
							}
						}
						parties[leader.party.id].count++;
						return parties;
					}, {})).sort((a, b) => b.count - a.count || a.id - b.id).slice(0, 4)
				});
			}).catch(e => {
				console.error(e);
			});
	}

	componentDidUpdate() {
		if (this.props.onUpdate) {
			this.props.onUpdate();
		}
	}

	render() {
		return <Wrapper>
			<Left>
				<InterestingDistricts
					districts={this.state.districts}
					link={this.props.linkToSenate}
					showMoreBtn={false}
				/>
			</Left>
			<Middle>
				<Summary
					meta={this.state.meta}
					districts={this.props.districts}
					leaders={this.state.leaders}
					link={this.props.linkToSenate}
					parties={this.state.parties}
					logos={this.props.logos}
				/>
			</Middle>
			<Right>
				<WidgetList articles={this.props.articles} />
			</Right>
		</Wrapper>;
	}
}

App.propTypes = {
	rootUrl: PropTypes.string.isRequired,
	year: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]).isRequired,
	districts: PropTypes.arrayOf(PropTypes.number).isRequired,
	linkToSenate: PropTypes.string.isRequired,
	articles: PropTypes.arrayOf(PropTypes.object),
	interestingDistricts: PropTypes.arrayOf(PropTypes.number),
	logos: PropTypes.object.isRequired,
	onUpdate: PropTypes.func
};

App.defaultProps = {
	linkToSenate: '#'
}
